<div class="d-flex justify-content-between pt-2">
    <div class="mt-page-size">
        {{ 'showing' | lang }}
        <select class="mt-select-page" style="width: auto" [(ngModel)]="_pageSize" (change)="onChangePageSize()">
            <option [ngValue]="10">10</option>
            <option [ngValue]="20">20</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
        </select>
        {{ 'from-total-of' | lang }} {{this.collectionSize}}
    </div>
    <div class="mt-pagination">
        <img (click)="goBackPage()" *ngIf="page > 1" appImageSelector alt="mt-image" imageType="icon" imageKey="left-pagination">
        <span>
        <input *ngIf="amountPages !== 1; else default"
            [(ngModel)]="inputPage"
            (keypress)="keyPress($event)"
            (keyup)="setPage()"
            (change)="setPage()"/> de {{ amountPages }}
        <ng-template #default>1</ng-template>
    </span>
        <img (click)="advancePage()" alt="mt-image" *ngIf="page < amountPages" appImageSelector imageType="icon"
            imageKey="right-pagination">
    </div>
</div>